"use strict";
function isFunction(x) {
    return typeof x === 'function';
}
exports.isFunction = isFunction;



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/util/isFunction.js
// module id = 26
// module chunks = 0 1